// extracted by mini-css-extract-plugin
export default {"serial":"Serial__serial___UBqkH"};